import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import type { LucideIcon } from "lucide-react"

interface ObjectiveCardProps {
  isPending: boolean
  title: string
  Icon: LucideIcon
  value: string
}

export function ObjectiveCard({ isPending, Icon, title, value }: ObjectiveCardProps) {
  return (
    <Card className="overflow-hidden rounded-xl border-2 border-primary-500">
      <div className="bg-primary-500 px-2 py-2 text-center text-sm font-medium text-primary-foreground">
        {title}
      </div>
      <CardContent className="flex items-center justify-center gap-2 p-4">
        <Icon className="size-6 text-primary" strokeWidth={1.5} />
        {isPending ? (
          <Skeleton className="h-6 w-12" />
        ) : (
          <span className="text-xl font-bold text-primary-500">{value}</span>
        )}
      </CardContent>
    </Card>
  )
}
